import React from 'react';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const AmbiencePreview = () => {
  const ambienceImages = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1636055832732-5869c97a6090",
    alt: "Modern restaurant interior with warm pendant lighting, wooden tables with colorful cushioned chairs, exposed brick walls with Mexican art, and lush green plants",
    title: "Vibrant Interiors",
    description: "Warm lighting and colorful decor"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1624583338957-4d155ca886dc",
    alt: "Cozy restaurant booth seating with red leather upholstery, wooden table with condiments, warm overhead lighting, and decorative wall art creating intimate dining space",
    title: "Comfortable Seating",
    description: "Perfect for groups and families"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1590785114025-a3f09a00a1b6",
    alt: "Rustic exposed brick wall decorated with vintage Mexican posters, neon signs, colorful papel picado banners, and authentic street food photography",
    title: "Authentic Vibe",
    description: "Street food culture meets modern design"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1597992619310-838ebc5cc6ab",
    alt: "Happy diverse group of friends toasting with colorful drinks at restaurant table filled with tacos, nachos, and Mexican dishes in warm ambient lighting",
    title: "Community Spirit",
    description: "Where friends become family"
  }];


  return (
    <section className="py-16 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4">
            Experience the Vibe
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Step into our vibrant space where authentic Mexican street food culture meets modern comfort
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {ambienceImages?.map((item) =>
          <div
            key={item?.id}
            className="group relative overflow-hidden rounded-xl h-80 cursor-pointer animate-fade-in">

              <Image
              src={item?.image}
              alt={item?.alt}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="text-xl font-semibold text-white mb-2">
                  {item?.title}
                </h3>
                <p className="text-white/90 text-sm">
                  {item?.description}
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="bg-card rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-4">
              <Icon name="Camera" size={24} color="var(--color-primary)" />
              <span className="text-primary font-semibold">Virtual Tour</span>
            </div>
            <h3 className="text-3xl font-bold text-foreground mb-4">
              Explore Our Space Before You Visit
            </h3>
            <p className="text-muted-foreground mb-6">
              Take a 360° virtual tour of our restaurant and discover the perfect spot for your next meal. From cozy corners to vibrant communal tables, find your ideal dining experience.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="Eye"
                iconPosition="left">

                View Gallery
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="MapPin"
                iconPosition="left">

                Find Location
              </Button>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="relative w-64 h-64 rounded-full overflow-hidden border-8 border-primary/20">
              <Image
                src="https://images.unsplash.com/photo-1717800397176-54509e9cdd9a"
                alt="Circular preview of restaurant interior showing warm lighting, wooden furniture, colorful Mexican decor, and welcoming atmosphere"
                className="w-full h-full object-cover" />

              <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center">
                  <Icon name="Play" size={32} color="var(--color-primary)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default AmbiencePreview;